import { Button } from '@jq4race/ui';

import { LOCALE_LABELS } from './config.js';
import { useLanguage } from './use-language.js';

export interface LanguageSwitcherProps {
  className?: string;
}

export function LanguageSwitcher({ className }: LanguageSwitcherProps) {
  const { language, setLanguage, locales } = useLanguage();

  return (
    <div className={className ? `flex gap-2 ${className}` : 'flex gap-2'}>
      {locales.map((locale) => (
        <Button
          key={locale}
          type="button"
          size="sm"
          variant={language === locale ? 'default' : 'outline'}
          onClick={() => setLanguage(locale)}
          aria-pressed={language === locale}
          aria-label={LOCALE_LABELS[locale]}
        >
          {locale.toUpperCase()}
        </Button>
      ))}
    </div>
  );
}
